import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { Box, Typography, Tooltip } from "@mui/material";

export function CmSendStatus({ send, loading, message, isChecked }) {
  return (
    <Tooltip title={message || ""}>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center", justifyContent: "center" }}>
        {loading && isChecked && (
          <Typography sx={{ color: "#00000099" }}>Enviando...</Typography>
        )}
        {send === "pending" && !loading && (
          <>
            <ErrorOutlineOutlinedIcon sx={{ color: "#FF7A39" }} />
            <Typography sx={{ color: "#00000099" }}>Pendiente de envío</Typography>
          </>
        )}
        {send === "success" && !loading && (
          <>
            <CheckCircleOutlineIcon sx={{ color: "#61B477" }} />
            <Typography sx={{ color: "#00000099" }}>Enviado</Typography>
          </>
        )}
        {send === "error" && !loading && (
          <>
            <CancelOutlinedIcon sx={{ color: "#D32F2F" }} />
            <Typography sx={{ color: "#00000099" }}>Error en el envío</Typography>
          </>
        )}
      </Box>
    </Tooltip>
  );
}
